import { Component, OnInit } from '@angular/core';
import { AttendanceService } from 'src/app/services/attendance/attendance.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-attendance-summary-report',
  templateUrl: './attendance-summary-report.component.html',
  styleUrls: ['./attendance-summary-report.component.css']
})
export class AttendanceSummaryReportComponent implements OnInit {


  constructor(private attendanceservice: AttendanceService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ClassList: any;
  SectionList: any;
  YearList: any;
  StudentMonthlyAttendanceList: any;
  StudentMonthlyDayList: any;
  CurrentStatusHeader: any;
  Submitted: boolean = false;
  FilePath: any;


  StudentMonthlyAttendanceModel = {
    StudentAttendanceID: 0,
    ClassID: 0,
    SectionID: 0,
    AtMonth: 0,
    AtYear: 0,
    StudentStatus: 1,
    Print: '',
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
  }

  Clear() {
    this.StudentMonthlyAttendanceModel.ClassID = 0;
    this.StudentMonthlyAttendanceModel.SectionID = 0;
    this.StudentMonthlyAttendanceModel.AtMonth = 0;
    this.StudentMonthlyAttendanceModel.AtYear = 0;
    this.StudentMonthlyAttendanceModel.StudentStatus = 1;
    this.Submitted = false;
    this.StudentMonthlyAttendanceList = [];
  }

  GetAttendanceSummaryReport(valid) {
    this.Submitted = true;
    this.StudentMonthlyAttendanceList = [];
    if (valid) {
      this.StudentMonthlyAttendanceModel.FromDate = this.StudentMonthlyAttendanceModel.FromDate != null && this.StudentMonthlyAttendanceModel.FromDate != '' ? moment(this.StudentMonthlyAttendanceModel.FromDate).format('DD-MMM-YYYY') : '';
      this.StudentMonthlyAttendanceModel.ToDate = this.StudentMonthlyAttendanceModel.ToDate != null && this.StudentMonthlyAttendanceModel.ToDate != '' ? moment(this.StudentMonthlyAttendanceModel.ToDate).format('DD-MMM-YYYY') : '';
      this.spinnerService.show();
      this.attendanceservice.GetAttendanceSummaryReport(JSON.stringify(this.StudentMonthlyAttendanceModel)).subscribe((data: any) => {
        this.StudentMonthlyAttendanceList = data.AttendanceList;
        this.Submitted = false;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
      });
    }


  };




  ngOnInit() {

    var dtCurrent = new Date();
    var year = dtCurrent.getFullYear();
    this.YearList = [];
    var item = {
      ItemId: 0,
      ItemName: '---Select---'
    }
    this.YearList.push(item);
    for (var i = year; i >= year - 2; i--) {
      item = {
        ItemId: i,
        ItemName: i.toString()
      }
      this.YearList.push(item);
    }
    this.BindClass();
    this.GetSection();
  }

  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetSection() {
    this.StudentMonthlyAttendanceModel.SectionID = 0;
    var itemBo = {
      'ItemId': this.StudentMonthlyAttendanceModel.ClassID,
    };
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };


  // Download

  GetAttendanceSummaryReportDownload(valid) {
    this.Submitted = true;
    this.StudentMonthlyAttendanceModel.Print = 'P';

    if (valid) {
      this.spinnerService.show();
      this.attendanceservice.GetAttendanceSummaryReport(JSON.stringify(this.StudentMonthlyAttendanceModel)).subscribe((data: any) => {
        this.StudentMonthlyAttendanceModel.Print = '';
        this.Submitted = false;
        this.FilePath = data.FilePathUrl;
        window.location = this.FilePath;
        this.spinnerService.hide();
      });
    }

  };

  // Print

  Print() {

    var url = "attendancesummaryreportprint?ReportType=PrintAttendance&ClassID=" + this.StudentMonthlyAttendanceModel.ClassID + "&SectionID=" + this.StudentMonthlyAttendanceModel.SectionID + "&ToDate=" + moment(this.StudentMonthlyAttendanceModel.ToDate).format('DD-MMM-YYYY') + "&FromDate=" + moment(this.StudentMonthlyAttendanceModel.FromDate).format('DD-MMM-YYYY');
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  }

}


